import React from "react";
import "./ChatBox.css"
import { AccountType } from "../utility/enums";

function formatFileSize(bytes) {
  if (!bytes) return "0 KB";
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(0)} kb`;
  return `${(kb / 1024).toFixed(0)} mb`;
}

const UserSystemMessage = ({ msg, userData }) => {
  return (
    <div className={`message ${userData.role === AccountType.CLIENT  ? 'sent-message' : 'sent-message rounded-tl-[12px] rounded-tr-[12px] rounded-br-[12px] rounded-bl-none'} user-system-msg`}>
      <div
        className="system-message-content"
        dangerouslySetInnerHTML={{ __html: msg.message }}
      />

      {msg.files?.length > 0 && (
        <div className="system-message-files">
          {msg.files.map((file, index) => (
            <div key={index} className="file-item">
              <div className="file-icon">
                <img
                  width={27}
                  height={27}
                  src={require('../assets/revision-file-icon.png')}
                  alt="file-icon"
                />
              </div>
              <div className="file-info">
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="file-name"
                >
                  {file.name}
                </a>
                <span className="file-size">{formatFileSize(file.size)}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      <span className="messageTime">
        {new Date(msg.timestamp).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </span>
    </div>
  );
};

export default UserSystemMessage;
